import { noop } from 'lodash-es';

import { IUseBarcodeScanner, IUseBarcodeScannerProps } from './types';

export const useBarcodeScanner = (() => ({
  clearData: noop,
  deviceData: {
    data: null,
    error: null
  },
  startRead: () => Promise.resolve(0),
  stopRead: () => Promise.resolve()
})) as (opts: IUseBarcodeScannerProps) => IUseBarcodeScanner;
